export const UNFREEZE_TIME_MINUTES = 2;
export const TEST_PHONE_NUMBER = '4150000000';

// DAPI Login error codes
export const LOGIN_RESPONSE_MAX_ATTEMPTS_EXCEEDED = 'Maximum attempts exceeded';
export const LOGIN_RESPONSE_WRONG_OTP = 'Invalid code: wrong code';
export const LOGIN_RESPONSE_ACCOUNT_VERIFICATION_REQUIRED =
  'DapiAdditionalVerificationRequired: Last name';
export const LOGIN_RESPONSE_ACCOUNT_VERIFICATION_FAIL =
  'DapiAdditionalVerificationFailed: Last name';

export const PHONE_FIELD_NAME = 'phone';
export const CODE_FIELD_NAME = 'code';
export const LAST_NAME_FIELD_NAME = 'last_name';
export const DOB_FIELD_NAME = 'date_of_birth';
export const PINK_DOOR_ACCEPTED_FIELD_NAME = 'pinkDoorAccepted';
export const TOS_ACCEPTED_FIELD_NAME = 'tosAccepted';
